import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  if (lenis) return lenis;
  lenis = new Lenis({ duration: 1.15, smoothWheel: true });
  let raf;
  const loop = (t) => {
    lenis.raf(t);
    raf = requestAnimationFrame(loop);
  };
  requestAnimationFrame(loop);

  const onClick = (e) => {
    const anchor = e.target.closest('a[href^="#"]');
    if (!anchor) return;
    const hash = anchor.getAttribute("href");
    if (hash.length > 1 && document.querySelector(hash)) {
      e.preventDefault();
      lenis.scrollTo(hash, { offset: -72, duration: 1.4 });
    }
  };
  document.addEventListener("click", onClick);
  return lenis;
}

export function scrollToSection(id, offset = -72) {
  const el = document.querySelector(id);
  if (!el) return false;
  if (lenis) lenis.scrollTo(id, { offset, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
  return true;
}

export function scrollTop() {
  if (lenis) lenis.scrollTo(0, { immediate: true });
  else window.scrollTo(0, 0);
}
